var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWbnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_32809)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5951 12L6.60375 15.1731L9.2999 16.7596V18.6173L5.02586 16.1106V11.0721L6.5951 12ZM6.5951 8.82693V10.676L5.0249 9.74712V7.89808L6.5951 6.96924L8.17298 7.89808L6.5951 8.82693ZM10.4259 7.89808L11.9961 6.96924L13.5739 7.89808L11.9961 8.82693L10.4259 7.89808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 14.5154V12.6577L9.30017 13.5865V15.4356L7.72998 14.5154ZM10.4261 17.425L11.9963 18.3539L13.5742 17.425V19.274L11.9963 20.2029L10.4261 19.274V17.425ZM15.8261 7.89808L17.3963 6.96924L18.9742 7.89808V9.74712L17.3963 10.676V8.82693L15.8261 7.89808ZM17.3963 15.1731L17.405 12L18.9752 11.0712V16.1096L14.7011 18.6164V16.7587L17.3963 15.1731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2704 14.5154L14.7002 15.4356V13.5866L16.2704 12.6577V14.5154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2704 9.48462L16.279 11.3423L13.5752 12.9288V16.1096L12.005 17.0298L10.4348 16.1096V12.9288L7.73094 11.3423V9.48462L9.30786 8.55577L11.9954 10.15L14.6992 8.55577L16.2771 9.48462H16.2704ZM7.72998 6.3125L11.9963 3.79712L16.2704 6.3125L14.7002 7.24135L11.9963 5.64712L9.30017 7.24135L7.72998 6.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_32809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbnb);
export default __webpack_public_path__ + "static/media/wbnb.6357156ee4e807c01631fbce10fd35f0.svg";
export { ForwardRef as ReactComponent };